import { render, staticRenderFns } from "./mobileMenu.vue?vue&type=template&id=5b58a2c8&scoped=true"
import script from "./mobileMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./mobileMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mobileMenu.vue?vue&type=style&index=0&id=5b58a2c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b58a2c8",
  null
  
)

export default component.exports